"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.promise.js");

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function doRequest(opts) {
  if (opts) {
    return new Promise(async (resolve, reject) => {
      try {
        await _axios.default.get(opts.url, opts.body).then(response => resolve(response.data));
      } catch (error) {
        reject(error);
      }
    });
  }
}

function request(opts) {
  return doRequest(opts).then(function (response) {
    return response;
  }).catch(function (reason) {
    let message = 'Error requesting: ' + reason.message;
    const err = Error(message);
    err.status = reason.response && reason.response.statusCode;
    throw err;
  });
}

var _default = request;
exports.default = _default;